import React from 'react';
const CART_URL = 'https://mujeresempoderadas.lat/cart/add?id=52459756126507&quantity=1';
export function BonusStack() {
  return <section className="w-full" style={{
    background: 'var(--bg-muted)'
  }} aria-label="Bonos incluidos" data-id="element-1">
      <div className="max-w-2xl mx-auto px-4 py-10 md:py-16" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-3">
          <div className="section-accent" data-id="element-4" />
          <p className="eyebrow mb-3" data-id="element-5">Incluido hoy gratis</p>
          <h2 className="text-2xl md:text-3xl mb-2" style={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 600,
          color: 'var(--text-primary)',
          letterSpacing: '-0.02em'
        }} data-id="element-6">
            Reclamá estos{' '}
            <span style={{
            color: 'var(--color-gold)'
          }} data-id="element-7">
              4 Bonos Exclusivos
            </span>{' '}
            si entrás ahora.
          </h2>
          <p className="text-base italic" style={{
          fontFamily: 'var(--font-heading)',
          color: 'var(--text-muted)',
          fontWeight: 500
        }} data-id="element-8">
            <em data-id="element-9">
              Si entras ahora te daré 4 bonos especiales por tiempo limitado…
            </em>
          </p>
        </div>

        {/* Bonus cards — 2x2 grid */}
        <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-10">
          {/* Bonus 1 — Cocina Sin Riesgo */}
          <div className="rounded-2xl overflow-hidden flex flex-col" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-11">
            <div className="w-full overflow-hidden" aria-label="Imagen Bono 1" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/iKThP295Nx8pehugPpZUSp/20260303_1020_Image_Generation_simple_compose_01kjsxp0qtfaeab4g22bhx0zk1_(1).webp" alt="Cocina Sin Riesgo — Manual para celíacos, diabéticos e intolerantes a la lactosa" className="w-full object-cover" style={{
              display: 'block',
              aspectRatio: '4/3',
              objectFit: 'cover'
            }} data-id="element-13" />
            </div>
            <div className="p-3 flex flex-col flex-1" data-id="element-14">
              <p className="eyebrow m-0 mb-1" style={{
              color: 'var(--color-gold)'
            }} data-id="element-15">
                BONO #1:
              </p>
              <h3 className="text-sm mb-1.5 leading-snug" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)'
            }} data-id="element-16">
                Cocina Sin Riesgo
              </h3>
              <p className="text-xs leading-relaxed m-0 mb-3 flex-1" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-17">
                Manual para celíacos, diabéticos e intolerantes a la lactosa
              </p>
              <div className="text-center mt-auto" data-id="element-18">
                <p className="text-sm line-through m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-muted)'
              }} data-id="element-19">
                  $24.999 ARS
                </p>
                <p className="text-lg font-bold m-0" style={{
                fontFamily: 'var(--font-heading)',
                color: 'var(--color-gold)'
              }} data-id="element-20">
                  ¡GRATIS!
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 2 — Calculadora Ahorro Real */}
          <div className="rounded-2xl overflow-hidden flex flex-col" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-21">
            <div className="w-full overflow-hidden" aria-label="Imagen Bono 2" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/vHBHGB8QZUbmDk8jBnRT4g/20260303_1030_Image_Generation_simple_compose_01kjsy7cqcfamtdxydt6hfjn6b_(1).webp" alt="Calculadora Ahorro Real — Mirá en números cuánto recuperás por mes" className="w-full object-cover" style={{
              display: 'block',
              aspectRatio: '4/3',
              objectFit: 'cover'
            }} data-id="element-23" />
            </div>
            <div className="p-3 flex flex-col flex-1" data-id="element-24">
              <p className="eyebrow m-0 mb-1" style={{
              color: 'var(--color-gold)'
            }} data-id="element-25">
                BONO #2:
              </p>
              <h3 className="text-sm mb-1.5 leading-snug" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)'
            }} data-id="element-26">
                Calculadora Ahorro Real
              </h3>
              <p className="text-xs leading-relaxed m-0 mb-3 flex-1" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-27">
                Mirá en números cuánto recuperás por mes
              </p>
              <div className="text-center mt-auto" data-id="element-28">
                <p className="text-sm line-through m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-muted)'
              }} data-id="element-29">
                  $6.999 ARS
                </p>
                <p className="text-lg font-bold m-0" style={{
                fontFamily: 'var(--font-heading)',
                color: 'var(--color-gold)'
              }} data-id="element-30">
                  ¡GRATIS!
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 3 — Checklist Cero Error */}
          <div className="rounded-2xl overflow-hidden flex flex-col" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-31">
            <div className="w-full overflow-hidden" aria-label="Imagen Bono 3" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/ir7kedyJmWLLHwEVbD721C/20260303_1032_Image_Generation_simple_compose_01kjsyb7qffs3a4tvzay6ymyr9_(1).webp" alt="Checklist Cero Error — Listas de compras, inventario de freezer y planificador semanal" className="w-full object-cover" style={{
              display: 'block',
              aspectRatio: '4/3',
              objectFit: 'cover'
            }} data-id="element-33" />
            </div>
            <div className="p-3 flex flex-col flex-1" data-id="element-34">
              <p className="eyebrow m-0 mb-1" style={{
              color: 'var(--color-gold)'
            }} data-id="element-35">
                BONO #3:
              </p>
              <h3 className="text-sm mb-1.5 leading-snug" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)'
            }} data-id="element-36">
                Checklist Cero Error
              </h3>
              <p className="text-xs leading-relaxed m-0 mb-3 flex-1" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-37">
                Listas de compras, inventario de freezer y planificador semanal
              </p>
              <div className="text-center mt-auto" data-id="element-38">
                <p className="text-sm line-through m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-muted)'
              }} data-id="element-39">
                  $9.999 ARS
                </p>
                <p className="text-lg font-bold m-0" style={{
                fontFamily: 'var(--font-heading)',
                color: 'var(--color-gold)'
              }} data-id="element-40">
                  ¡GRATIS!
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 4 — Ruta Express */}
          <div className="rounded-2xl overflow-hidden flex flex-col" style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border-default)',
          boxShadow: 'var(--shadow-sm)'
        }} data-id="element-41">
            <div className="w-full overflow-hidden" aria-label="Imagen Bono 4" data-id="element-42">
              <img src="https://cdn.magicpatterns.com/uploads/sv69gUXRpJBDdrG7r6o9Sj/20260303_1048_Image_Generation_simple_compose_01kjsz9mz4e7ns102pnmvbbwmq_(1).webp" alt="Ruta Express — 90 Min, Empezá HOY mismo sin leer todo el sistema" className="w-full object-cover" style={{
              display: 'block',
              aspectRatio: '4/3',
              objectFit: 'cover'
            }} data-id="element-43" />
            </div>
            <div className="p-3 flex flex-col flex-1" data-id="element-44">
              <p className="eyebrow m-0 mb-1" style={{
              color: 'var(--color-gold)'
            }} data-id="element-45">
                BONO #4:
              </p>
              <h3 className="text-sm mb-1.5 leading-snug" style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 600,
              color: 'var(--text-primary)'
            }} data-id="element-46">
                Ruta Express — 90 Min
              </h3>
              <p className="text-xs leading-relaxed m-0 mb-3 flex-1" style={{
              fontFamily: 'var(--font-body)',
              color: 'var(--text-secondary)'
            }} data-id="element-47">
                Empezá HOY mismo sin leer todo el sistema
              </p>
              <div className="text-center mt-auto" data-id="element-48">
                <p className="text-sm line-through m-0" style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-muted)'
              }} data-id="element-49">
                  $7.999 ARS
                </p>
                <p className="text-lg font-bold m-0" style={{
                fontFamily: 'var(--font-heading)',
                color: 'var(--color-gold)'
              }} data-id="element-50">
                  ¡GRATIS!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Total Value Box */}
        <div className="rounded-2xl overflow-hidden" style={{
        border: '1.5px solid var(--border-gold)',
        boxShadow: '0 4px 32px rgba(184,146,42,0.12)'
      }} data-id="element-51">
          {/* Product image above header */}
          <div className="w-full overflow-hidden" data-id="element-52">
            <img src="https://cdn.magicpatterns.com/uploads/avXfojrAUQ7PsUmUipPzNu/20260303_1146_Image_Generation_remix_01kjt2hag0fe6swnp6e4ws1vcz_(1).webp" alt="Sistema 10x2™ — Todo lo que recibís" className="w-full object-cover" style={{
            display: 'block',
            maxHeight: '220px',
            objectPosition: 'center'
          }} data-id="element-53" />
          </div>
          <div className="px-5 py-3 text-center" style={{
          background: 'linear-gradient(135deg, #C9A84C 0%, #B8922A 100%)'
        }} data-id="element-54">
            <p className="font-bold text-sm m-0 text-white" style={{
            fontFamily: 'var(--font-body)',
            letterSpacing: '0.15em',
            textTransform: 'uppercase'
          }} data-id="element-55">
              Todo Lo Que Recibís Hoy
            </p>
          </div>
          <div className="px-5 py-3" style={{
          background: 'var(--bg-surface)'
        }} data-id="element-56">
            {[{
            label: '✓ Sistema 10x2™ Completo — Método por Bloques',
            price: '$29.999',
            type: 'strike'
          }, {
            label: '✓ Piloto Automático + Auditoría de Freezer',
            price: 'Incluido',
            type: 'included'
          }, {
            label: '✓ Acceso de por vida + Actualizaciones',
            price: 'Incluido',
            type: 'included'
          }, {
            label: '🎁 Bono: Cocina Sin Riesgo',
            price: '$24.999',
            type: 'strike'
          }, {
            label: '🎁 Bono: Calculadora Ahorro Real',
            price: '$6.999',
            type: 'strike'
          }, {
            label: '🎁 Bono: Checklist Cero Error',
            price: '$9.999',
            type: 'strike'
          }, {
            label: '🎁 Bono: Ruta Express 90 Min',
            price: '$7.999',
            type: 'strike'
          }].map((row, i) => <div key={i} className="value-row" data-id="element-57">
                <span style={{
              fontWeight: row.type === 'included' ? 400 : 500,
              color: 'var(--text-secondary)'
            }} data-id="element-58">
                  {row.label}
                </span>
                {row.type === 'strike' ? <span className="text-sm line-through" style={{
              color: 'var(--text-muted)'
            }} data-id="element-59">
                    {row.price}
                  </span> : <span className="text-xs font-semibold px-2 py-0.5 rounded" style={{
              background: 'var(--color-accent-light)',
              color: 'var(--color-accent)'
            }} data-id="element-60">
                    {row.price}
                  </span>}
              </div>)}
          </div>
          <div className="px-5 py-7 text-center" style={{
          background: 'var(--bg-surface)',
          borderTop: '1px solid var(--border-light)'
        }} data-id="element-61">
            <p className="eyebrow mb-4" data-id="element-62">Precio de oferta:</p>
            <p className="text-2xl font-bold line-through mb-1" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-63">
              $87.995 ARS
            </p>
            <p className="text-5xl font-bold mb-4" style={{
            fontFamily: 'var(--font-heading)',
            color: 'var(--color-primary)',
            lineHeight: 1.1,
            letterSpacing: '-0.02em'
          }} data-id="element-64">
              $19.999 ARS
            </p>
            <p className="text-sm m-0" style={{
            fontFamily: 'var(--font-body)',
            color: 'var(--text-muted)'
          }} data-id="element-65">
              Pago único · Sin suscripciones · Sin cargos ocultos
            </p>
          </div>
        </div>

        {/* CTA — outside the value box */}
        <div className="mt-5" data-id="element-66">
          <a href={CART_URL} className="btn-cta-gold btn-cta-gold-pulse w-full text-base px-6 py-4 rounded-xl mb-2 block text-center" data-id="element-67">
            AGREGAR AL CARRITO &gt;&gt;
          </a>
          <p className="text-sm text-center" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--color-accent)'
        }} data-id="element-68">
            ✓ Descarga inmediata de todo el paquete
          </p>
        </div>
      </div>
    </section>;
}